import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AggregatorFeatureFlagGuard } from '@core/guards/aggregator-feature-flag/aggregator-feature-flag.guard';
import { FeatureFlagGuard } from '@core/guards/feature-flag/feature-flag.guard';
import { ComingSoonComponent } from '@core/pages/coming-soon/coming-soon.component';
import { ErrorPageComponent } from '@core/pages/error/error-page.component';
import { NotFoundComponent } from '@core/pages/not-found/not-found.component';
import { AggregatorFeatureFlag } from '@env/aggregator/aggregator.interface';
import { FeatureFlag } from '@env/environment.interface';
import { AuthenticatedComponent } from '@features/authenticated/authenticated.component';

// TODO: change route paths to kebab-case (lower case with dashes) [ future release ]
const routes: Routes = [
  {
    path: '',
    component: AuthenticatedComponent,
    children: [
      {
        path: 'dashboard',
        loadChildren: () =>
          import('../dashboard/dashboard.module').then((m) => m.DashboardModule)
      },
      {
        path: 'Contacts',
        loadChildren: () =>
          import('../contacts/contacts.module').then((m) => m.ContactsModule)
      },
      {
        path: 'Leads',
        loadChildren: () =>
          import('../leads/leads.module').then((m) => m.LeadsModule)
      },
      {
        path: 'Tasks',
        loadChildren: () =>
          import('../tasks/tasks.module').then((m) => m.TasksModule)
      },
      {
        path: 'Opportunities',
        loadChildren: () =>
          import('../opportunities/opportunities.module').then(
            (m) => m.OpportunitiesModule
          )
      },
      {
        path: 'library',
        loadChildren: () =>
          import('../library/library.module').then((m) => m.LibraryModule)
      },
      {
        path: 'products-matrix',
        loadChildren: () =>
          import('../product-matrix/product-matrix.module').then(
            (m) => m.SparkProductMatrixModule
          ),
        canActivate: [AggregatorFeatureFlagGuard, FeatureFlagGuard],
        data: {
          aggregatorFeatureFlag: AggregatorFeatureFlag.ProductMatrix,
          featureFlag: FeatureFlag.ProductMatrix
        }
      },
      {
        path: 'calculators',
        loadChildren: () =>
          import('../calculators/calculators.module').then(
            (m) => m.CalculatorsModule
          )
      },
      {
        path: 'reports',
        loadChildren: () =>
          import('../reports/reports.module').then((m) => m.ReportsModule),
        canActivate: [FeatureFlagGuard],
        data: {
          aggregatorFeatureFlag: AggregatorFeatureFlag.Reports,
          featureFlag: FeatureFlag.Reports
        }
      },
      // TODO: not implemented [future release]
      // {
      //   path: 'Settings',
      //   loadChildren: () => import('./features/settings/settings.module').then(m => m.SettingsModule)
      // },
      {
        path: 'coming-soon',
        component: ComingSoonComponent,
        title: 'Coming Soon'
      },
      {
        path: 'error',
        component: ErrorPageComponent,
        title: 'Error'
      },
      {
        path: 'not-found',
        component: NotFoundComponent,
        title: 'Page not found'
      },
      {
        path: '**',
        component: NotFoundComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthenticatedRoutingModule {}
